import type { A2PDeadlineStatus } from 'api/generated/types';
import i18n from 'i18n';
import { SHELL_NS } from 'recruiter-i18n/namespaces/shell';

export type SmsRegistrationDeadlineDisplay = {
  tone: 'warning' | 'blocked';
  title: string;
  message: string;
};

/** Maps the org's deadline state to banner copy; null means show nothing. */
export const getSmsRegistrationDeadlineDisplay = (
  deadline: A2PDeadlineStatus | null
): SmsRegistrationDeadlineDisplay | null => {
  if (!deadline) return null;
  switch (deadline.state) {
    case 'counting_down': {
      const days = Math.max(0, deadline.days_remaining ?? 0);
      return {
        tone: 'warning',
        title: i18n.t('smsDeadline.requiredTitle', { ns: SHELL_NS }),
        message:
          days === 0
            ? i18n.t('smsDeadline.dueToday', { ns: SHELL_NS })
            : i18n.t('smsDeadline.dueInDays', { ns: SHELL_NS, count: days }),
      };
    }
    case 'locked':
      return {
        tone: 'blocked',
        title: i18n.t('smsDeadline.overdueTitle', { ns: SHELL_NS }),
        message: i18n.t('smsDeadline.paused', { ns: SHELL_NS }),
      };
    case 'none':
    case 'satisfied':
      return null;
  }
};
